// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Notifications from 'react-notification-system-redux';

import Loader from '../../components/Loader/Loader';
import FormWrapper from '../../components/shared/FormWrapper';
import StandardTextEditForm from '../../components/StandardText/Edit';

import {
    loadDefaultTexts,
    updateDefaultTexts,
} from '../../redux/reducers/defaulttext';

import {
    loadAgreementTypes,
    loadInsuranceTypes,
    updateAgreementTypes,
    updateInsuranceTypes,
} from '../../redux/reducers/property';

class StandardText extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(loadDefaultTexts());
        this.props.dispatch(loadAgreementTypes());
        this.props.dispatch(loadInsuranceTypes());
    }

    onSubmit(formValues, dispatch) {
        const agreementTypeValues = formValues
            ? Object.keys(formValues)
                  .filter(fieldName => fieldName.indexOf('agreementType-') > -1)
                  .reduce((result, fieldName) => {
                      const agreementTypeId = fieldName.substr(
                          fieldName.indexOf('-') + 1
                      );
                      result[agreementTypeId] = formValues[fieldName];
                      return result;
                  }, {})
            : {};

        const insuranceTypeValues = formValues
            ? Object.keys(formValues)
                  .filter(fieldName => fieldName.indexOf('insuranceType-') > -1)
                  .reduce((result, fieldName) => {
                      const insuranceTypeId = fieldName.substr(
                          fieldName.indexOf('-') + 1
                      );
                      result[insuranceTypeId] = formValues[fieldName];
                      return result;
                  }, {})
            : {};

        const defaultTextValues = formValues
            ? Object.keys(formValues)
                  .filter(fieldName => fieldName.indexOf('defaultText-') > -1)
                  .reduce((result, fieldName) => {
                      const defaultTextId = fieldName.substr(
                          fieldName.indexOf('-') + 1
                      );
                      result[defaultTextId] = formValues[fieldName];
                      return result;
                  }, {})
            : {};

        return Promise.all([
            dispatch(updateDefaultTexts(defaultTextValues)),
            dispatch(updateAgreementTypes(agreementTypeValues)),
            dispatch(updateInsuranceTypes(insuranceTypeValues)),
        ]).then(() => {
            dispatch(
                Notifications.success({
                    title: 'Standard text updated',
                    message: `The provided text has been saved successfully.`,
                    position: 'tc',
                    autoDismiss: 3,
                })
            );
        });
    }

    render() {
        const {
            agreementTypes,
            defaultTextItems,
            fetching,
            insuranceTypes,
        } = this.props;

        const hasData =
            !fetching &&
            defaultTextItems &&
            Object.keys(defaultTextItems).length > 0;

        let initialValues = {};

        if (hasData) {
            const defaultTextItemValues = Object.keys(
                defaultTextItems
            ).reduce((result, defaultTextId) => {
                result[`defaultText-${defaultTextId}`] =
                    defaultTextItems[defaultTextId].defaultTextContent || '';
                return result;
            }, {});

            const agreementTypeValues = Object.keys(
                agreementTypes
            ).reduce((result, agreementTypeId) => {
                result[`agreementType-${agreementTypeId}`] =
                    agreementTypes[agreementTypeId]
                        .propertyAgreementTypeDescription || '';
                return result;
            }, {});

            const insuranceTypeValues = Object.keys(
                insuranceTypes
            ).reduce((result, insuranceTypeId) => {
                result[`insuranceType-${insuranceTypeId}`] =
                    insuranceTypes[insuranceTypeId]
                        .propertyInsuranceDescription || '';
                return result;
            }, {});

            initialValues = Object.assign(
                {},
                defaultTextItemValues,
                agreementTypeValues,
                insuranceTypeValues
            );
        }

        return (
            <FormWrapper>
                {fetching && <Loader message="Loading, please wait..." />}

                {!fetching &&
                    hasData &&
                    <StandardTextEditForm
                        agreementTypes={agreementTypes}
                        defaultTextItems={defaultTextItems}
                        initialValues={initialValues}
                        insuranceTypes={insuranceTypes}
                        onSubmit={this.onSubmit}
                    />}
            </FormWrapper>
        );
    }
}

const mapStateToProps = state => {
    const defaulttext = state.defaulttext;
    const property = state.property;

    return {
        fetching:
            defaulttext.fetching ||
            property.agreementTypes.fetching ||
            property.insuranceTypes.fetching,
        defaultTextItems: defaulttext.defaultTexts,
        agreementTypes: property.agreementTypes.list,
        insuranceTypes: property.insuranceTypes.list,
    };
};

export default withRouter(connect(mapStateToProps)(StandardText));



// WEBPACK FOOTER //
// ./src/containers/StandardText/StandardText.js